export const propRules = {
  rules: {
    heading: "Normas del alojamiento",
    subheading:
      "Define los horarios de entrada y salida que se comunicarán al huésped durante el check-in.",
    cloneTitleNoun: "horarios",
    cloneItemNoun: "los horarios",
    bulkNoticePrefix:
      "Este cambio se aplicará a los {count} alojamientos vinculados a",
    checkinLabel: "Check-in",
    checkoutLabel: "Check-out",
    defaultCheckin: "Por defecto 15:00",
    defaultCheckout: "Por defecto 12:00",
    saving: "Guardando…",
    save: "Guardar",
    toasts: {
      loadError: "Error al cargar los datos del anuncio.",
      bulkApplied: "Normas aplicadas a {count} alojamientos",
      saveSuccess: "Normas guardadas con éxito",
      bulkPartialError: "Algunos alojamientos no se pudieron actualizar",
      saveError: "Error al guardar las normas",
    },
  },
  services: {
    cloneTitleNoun: "equipamiento y comodidades",
    cloneItemNoun: "el equipamiento y las comodidades",
    toasts: {
      saveSuccess: "Comodidades guardadas con éxito",
      saveError: "Error al guardar las comodidades",
    },
  },
  maintenance: {
    title: "Mantenimiento del alojamiento",
    scopeProperty: "Alojamiento completo",
    scopeUnits: "Unidades específicas",
    selectUnits: "Selecciona unidades",
    dateFrom: "Desde",
    dateTo: "Hasta",
    closeArrivals: "Cerrar llegadas (CTA)",
    closeDepartures: "Cerrar salidas (CTD)",
    applying: "Aplicando...",
    apply: "Aplicar mantenimiento",
    removing: "Quitando...",
    remove: "Quitar mantenimiento",
    toasts: {
      rangeScopeRequired: "Completa rango y ámbito (unidades o alojamiento).",
      applied: "Mantenimiento aplicado.",
      applyError: "Error al aplicar mantenimiento.",
      removed: "Mantenimiento retirado.",
      removeError: "Error al retirar mantenimiento.",
    },
  },
  propMaintenance: {
    title: "Mantenimiento del alojamiento",
    scopeProperty: "Alojamiento completo",
    scopeUnits: "Unidades específicas",
    selectUnits: "Selecciona unidades",
    dateFrom: "Desde",
    dateTo: "Hasta",
    closeArrivals: "Cerrar llegadas (CTA)",
    closeDepartures: "Cerrar salidas (CTD)",
    applying: "Aplicando...",
    apply: "Aplicar mantenimiento",
    removing: "Quitando...",
    remove: "Quitar mantenimiento",
    toasts: {
      rangeScopeRequired: "Completa rango y ámbito (unidades o alojamiento).",
      applied: "Mantenimiento aplicado.",
      applyError: "Error al aplicar mantenimiento.",
      removed: "Mantenimiento retirado.",
      removeError: "Error al retirar mantenimiento.",
    },
  },
};
